/* eslint-disable no-undef */
import { logDebugging } from '../../log/logger';
import AdUnit from './adUnit';
import ConsentManagement from './consentManagement';
import initPbJs from './initPbJs';
import Options from './options';
import loadScript from '../../utils/load_script';

export default class PrebidManager {
  constructor(idComponent, adData) {
    this.idComponent = idComponent;
    const { mediation } = adData.waterfall;
    this.containerId = this.getContainer().id;

    const { bids, options, url } = mediation[0].e;
    this.urlPrebidLibrary = url;
    const sizes = [this.getContainer().clientWidth, this.getContainer().clientHeight];
    this.adData = adData;
    this.adUnits = new AdUnit()
      .setCode(this.getContainer().id)
      .setMediaTypeVideo(sizes)
      .setBids(bids)
      .build();
    const consentManagement = new ConsentManagement()
      .setUsp(this.adData.timeout)
      .setGdpr(this.adData.consent !== '', this.adData.timeout)
      .build();
    this.options = new Options().setConsetManagement(consentManagement).build();

    // added and updated options from SSP
    this.options = Object.assign(this.options, options);
    logDebugging('prebid options ->', this.options);
    logDebugging('prebid adUntis', this.adUnits);
  }

  async init() {
    await loadScript(this.urlPrebidLibrary);

    logDebugging(`library ${this.urlPrebidLibrary} loaded`);
    initPbJs();
    return this.loadBid();
  }

  loadBid() {
    return new Promise((resolve) => {
      if (!this.adUnits) resolve(null);
      pbjs.que.push(() => {
        pbjs.addAdUnits(this.adUnits);
        pbjs.setConfig(this.options);
        pbjs.requestBids({
          timeout: this.adData.timeout,
          bidsBackHandler: (bids) => {
            logDebugging('prebid result->', bids);

            if (
              bids &&
              bids[this.containerId] &&
              bids[this.containerId].bids &&
              bids[this.containerId].bids[0]
            ) {
              resolve(bids[this.containerId].bids);
            } else {
              resolve(null);
            }
          },
        });
      });
    });
  }

  getContainer() {
    return document
      .getElementById(this.idComponent)
      .nextElementSibling.querySelector('#video-player-container>video');
  }
}
